document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.navbar-item a[href^="#"]').forEach((anchorLink) => {
    anchorLink.addEventListener('click', (event) => {
      const href = anchorLink.getAttribute('href');
      const targetId = href?.substring(1);
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      const rect = target.getBoundingClientRect();
      const scrollDirection = rect.top > 0 ? 'down' : 'up';

      window.scrollBy(0, scrollDirection === 'down' ? 1 : -1);

      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    });
  });
});
